
















































import Vue from 'vue'

export default Vue.extend({
  name: 'TotalAmountTable',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    tableData: [
      { text: 'Cтраховые взносы (кроме НПФ)', id: 'row1' },
      { text: 'Накопительный пенсионный фонд', id: 'row2' },
      { text: 'Пени и штрафы', id: 'row3' },
      { text: 'Отсроченные страховые взносы (кроме НПФ)', id: 'row4' },
      { text: 'Отсроченные страховые взносы - накопительный пенсионный фонд', id: 'row5' },
      { text: 'Отсроченные пени и штрафы', id: 'row6' },
      { text: 'Преемственная задолженность по взносам (кроме НПФ)', id: 'row7' },
      { text: 'Преемственная задолженность по взносам - Накопительный пенсионный фонд', id: 'row8' },
      { text: 'Преемственная задолженность по пеням и штрафам', id: 'row9' },
      { text: 'Проценты по предоставлению отсрочки', id: 'row10' }
    ],
    total: [
      { text: 'Переплата по страховым взносам (кроме НПФ)', id: 'row11' },
      { text: 'Переплата по санкциям', id: 'row12' },
      { text: 'Переплата по НПФ', id: 'row13' }
    ],
    formData: {}
  }),
  watch: {
    data(val) {
      if (val) this.formData = val
    }
  }
})
